<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer004" style="margin-top: 3em;">
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-5">To my dad and role model,</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-5">Donald Scott</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-5">1</span><span class="CharOverride-5">92</span><span class="CharOverride-5">7</span><span class="CharOverride-5">—</span><span class="CharOverride-5">2</span><span class="CharOverride-5">01</span><span class="CharOverride-5">4</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-6">—</span><span class="CharOverride-6">J</span><span class="CharOverride-6">.S.</span></p>
<p class="Basic-Paragraph ParaOverride-2"> </p>
</div>
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-5">To my biggest fan,</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-5">W</span><span class="CharOverride-5">orth Kirkman</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-5">1</span><span class="CharOverride-5">930—</span><span class="CharOverride-5">2</span><span class="CharOverride-5">0</span><span class="CharOverride-5">1</span><span class="CharOverride-5">5</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-6">—</span><span class="CharOverride-6">R</span><span class="CharOverride-6">.K.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NoYelling_EPUB-1.vue?4be2d8c8